// A short grey puff where an animal died of old age (ARCH §28.8: "a 6-particle grey puff,
// no chat, no sound"). Client chrome (ENG-1): a handful of small quads that drift up and
// fade over ~1 s, never part of the world mesh and never read by the sim.
import * as THREE from 'three';

const COUNT = 6;
const LIFE_MS = 1000;

interface Puff { meshes: THREE.Mesh[]; born: number; }

export class PuffRenderer {
  private readonly group = new THREE.Group();
  private readonly geo = new THREE.BoxGeometry(0.18, 0.18, 0.18);
  private readonly puffs: Puff[] = [];
  /** Puffs spawned so far — a probe for tests, like the other renderers' counts. */
  spawned = 0;

  constructor(scene: THREE.Scene) { scene.add(this.group); }

  spawn(x: number, y: number, z: number): void {
    const meshes: THREE.Mesh[] = [];
    for (let i = 0; i < COUNT; i++) {
      const mat = new THREE.MeshBasicMaterial({ color: 0x9a9a9a, transparent: true, opacity: 0.8 });
      const m = new THREE.Mesh(this.geo, mat);
      const a = (i / COUNT) * Math.PI * 2;
      m.position.set(x + Math.cos(a) * 0.3, y + 0.4, z + Math.sin(a) * 0.3);
      this.group.add(m);
      meshes.push(m);
    }
    this.puffs.push({ meshes, born: performance.now() });
    this.spawned++;
  }

  update(): void {
    const now = performance.now();
    for (let i = this.puffs.length - 1; i >= 0; i--) {
      const p = this.puffs[i]!;
      const t = (now - p.born) / LIFE_MS;
      for (const m of p.meshes) {
        m.position.y += 0.01;
        (m.material as THREE.MeshBasicMaterial).opacity = Math.max(0, 0.8 * (1 - t));
      }
      if (t < 1) continue;
      for (const m of p.meshes) { this.group.remove(m); (m.material as THREE.Material).dispose(); }
      this.puffs.splice(i, 1);
    }
  }
}
